import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';
import { VolumeOffRounded } from '@mui/icons-material';

import { INLINE_VERTICAL_PLAYER_INSTANCE_KEY } from '@/modules/common/components/Player/constants';
import {
  DISABLE_CAROUSEL_EVENT,
  ENABLE_CAROUSEL_EVENT,
  NEXT_CLIP_COMPLETE_EVENT,
} from '@/modules/common/components/Player/constants/events';
import { CHANNEL_LIST_PATH } from '@/modules/common/constants/routePath';

import { ChannelType } from '@/modules/common/types/channel';
import { VideoType } from '@/modules/common/types/video';

import { usePlayerWidget } from '@/modules/common/components/Player/helpers';
import { useTranslate } from '@/modules/common/helpers/i18n';

import Player from '../../../../common/components/Player/Player';
import { Button } from '@/mui/components';

import styles from './VideoPlayer.module.scss';

type Props = {
  video: VideoType;
  channel: ChannelType;
  onAdState: (state: boolean) => void;
  onEnded: () => void;
};

function Video(props: Props) {
  const location = useLocation();
  const LWP = usePlayerWidget(INLINE_VERTICAL_PLAYER_INSTANCE_KEY);
  const [adsState, setAdsState] = useState(false);
  const t = useTranslate();

  useEffect(() => {
    if (!matchPath(CHANNEL_LIST_PATH, location.pathname)) {
      LWP.pause();
    } else {
      LWP.play();
    }
  }, [props.video.mediaid, location.pathname]);

  return (
    <>
      <Player
        instanceKey={INLINE_VERTICAL_PLAYER_INSTANCE_KEY}
        video={props.video}
        playerPropsPassThrow={props.channel.playerPropsPassThrow}
        clipSource={props.channel.playlistId}
        listeners={{
          [NEXT_CLIP_COMPLETE_EVENT]: () => props.onEnded(),
          [ENABLE_CAROUSEL_EVENT]: () => {
            props.onAdState(false);
            setAdsState(false);
          },
          [DISABLE_CAROUSEL_EVENT]: () => {
            props.onAdState(true);
            setAdsState(true);
          },
        }}
      />
      {!adsState && (
        <div className={styles.Volume}>
          <Button
            aria-label={t.volumeButton.text()}
            type="button"
            variant="outlined"
            color="inherit"
            size="small"
            shape="circular"
            square
            startIcon={<VolumeOffRounded />}
          />
        </div>
      )}
    </>
  );
}

export default Video;
